import * as React from "react"
import type { SVGProps } from "react"
const SvgMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14.35 21.06 9 19.19l-4.65 1.8a1 1 0 0 1-.49.06 1 1 0 0 1-.44-.16 1 1 0 0 1-.3-.34 1 1 0 0 1-.12-.49V6.04q0-.33.19-.58a1 1 0 0 1 .51-.37L8.35 3.5l.31-.07a2 2 0 0 1 .99.07L15 5.39l4.65-1.8a1 1 0 0 1 .49-.07q.24.04.43.17a1 1 0 0 1 .32.33q.1.21.11.5v14.02a1 1 0 0 1-.19.57 1 1 0 0 1-.51.38l-4.65 1.57-.31.08a2 2 0 0 1-.99-.08M14 18.84V7.14l-4-1.4v11.7zm2 0 3-1V5.99l-3 1.15zm-11-.25 3-1.15V5.74l-3 1z" />
  </svg>
)
export default SvgMap
